import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebItem } from 'src/app/core/models/api/web-item.model';

@Component({
    selector: 'app-video-frame',
    templateUrl: './video-frame.component.html',
    styleUrls: ['./video-frame.component.scss']
})
export class VideoFrameComponent implements OnInit {

    @Input() items: WebItem[];

    constructor(private sanitizer: DomSanitizer) { }

    ngOnInit() { }

    getSafeResourceURL(videoUrl: string) {

        return this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl);

    }
}
